import { Code, GraduationCap, Layers, Award } from 'lucide-react';

export const stats = [
  { value: "3+", label: "Projects", icon: Code },
  { value: "2+", label: "Years Learning", icon: GraduationCap },
  { value: "10+", label: "Technologies", icon: Layers },
  { value: "96%", label: "HS Score", icon: Award }
];
